import React, { useRef, useEffect, useState } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, Col, Image, Row } from 'react-bootstrap'
import LogoWithTagLine from "../Components/Images/Logo with tagline.png"
import VissionAndValues from "../Components/Images/Our Vission and Values.png"
import ImpactCorousel from '../Components/SiteComponents/ImpactCorousel'
import SIPCalculatorChart from '../Components/SiteComponents/SIPChart'
import ServicesGrid from "../Components/SiteComponents/OurServices"
import TestimonialCarousel from "../Components/SiteComponents/TestimonialCarrousel"
import AppPromoSection from '../Components/SiteComponents/AppPromotion';
import MeetOurTeam from '../Components/SiteComponents/MeetOurTeam';
import Awards from '../Components/SiteComponents/Awards';
import YouTubeCarousel from '../Components/SiteComponents/YouTubeCarousel';
import AUMLineChart from '../Components/SiteComponents/AUMLineChart';
// import { LinkContainer } from 'react-router-bootstrap'

function HomeScreen() {
const textColRef = useRef(null);
  const [textHeight, setTextHeight] = useState("auto");

  useEffect(() => {
    if (textColRef.current) {
      setTextHeight(textColRef.current.clientHeight);
    }
  }, []);

  return (
    <div>      
    
        <br/>
        
        <Row className='py-2'>
            <Col md = {6}>
                <Row>
                {/* <h1>ValueFundz</h1> */}
                {/* <Image src = {LogoWithTagLine} fluid /> */}
                <p style = {{textAlign: 'justify' }} className='fs-5'>
                ValueFundz Private Limited is a leading AMFI-registered Mutual Fund Distributor & APMI
                Registered Portfolio Management Services (PMS) Distributor dedicated to delivering
                personalized wealth management and financial solutions. With a focus on empowering clients
                to achieve their financial goals, our services include portfolio management and mutual fund
                distribution. Our team consists of skilled professionals committed to maintaining the highest
                standards of integrity, trust, and customer satisfaction.
                </p>
                </Row>
                <Row className='my-3 '>
                    <ImpactCorousel />
                </Row>
            </Col>
            <Col md={6} className="d-flex align-items-start justify-content-center">
            <Image 
                src={VissionAndValues} 
                style={{ height: `auto`, width: 'auto', objectFit: 'contain' }} 
                fluid 
            />
            </Col>
        </Row>
        <Row className='my-5'>
            <Col>
                <h3 className='mb-4'>AUM Growth Over the Years</h3>
                <AUMLineChart />
            </Col>
        </Row>
        <Row>
            <SIPCalculatorChart />
        </Row>
        <Row>
            <ServicesGrid />
        </Row>
        <Row>
            <MeetOurTeam />
        </Row>
        <Row>
            <Awards/>
        </Row>
        <Row>
            <YouTubeCarousel/>
        </Row>
        <Row>
            <AppPromoSection />
        </Row>
        <Row>
            <TestimonialCarousel />
        </Row>
    </div>
  )
}

export default HomeScreen